import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import './utils/react-devtools-hook';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
